import { CanActivateFn, Router } from '@angular/router';
import { inject } from '@angular/core';
import { AuthStateService } from '../services/auth-state.service';

export const registerRedirectGuard: CanActivateFn = (route) => {
  const authState = inject(AuthStateService);
  const router = inject(Router);

  authState.loadState();
  const state = authState.registrationState();
  const roleParam = route.queryParamMap.get('role') as 'CLIENT' | 'TRADER' | null;

  let targetRole: 'CLIENT' | 'TRADER' = 'CLIENT';
  if (roleParam === 'TRADER') {
    targetRole = 'TRADER';
  } else if (roleParam === 'CLIENT') {
    targetRole = 'CLIENT';
  } else if (state.role) {
    targetRole = state.role;
  }

  authState.setRole(targetRole);

  if (state.isGoogleUser) {
    return router.createUrlTree(['/auth/register/phone']);
  }

  return router.createUrlTree(['/auth/register/details']);
};
